export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-10.2688a8fd.jpg";